import React, { FC } from 'react'

import { Card } from 'src/components/atoms'
import { InternalUserManagement } from 'src/components/organisms'

import { ProfileEntity, InternalUserDetailEntity } from 'src/types'

type Props = {
  user: InternalUserDetailEntity | ProfileEntity
  className?: string
}

export const InternalUserManagementCard: FC<Props> = ({ user, className }) => {
  return (
    <div className={className}>
      <Card padding="--s1">
        <InternalUserManagement user={user} />
      </Card>
    </div>
  )
}
